import script from "./KpiCards.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiCards.vue?vue&type=script&setup=true&lang=js"

import "./KpiCards.vue?vue&type=style&index=0&id=83a7886e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83a7886e"]])

export default __exports__